

<!-- Mobile Sidebar -->
<!-- <div class="mobile-sidebar-container"> -->
  <!-- Backdrop -->
 
      <!-- Navigation -->
      <!-- <div class="menu-section">
        <details class="menu-dropdown">
          <summary class="menu-item">
            <span class="menu-icon">👕</span>
            <span class="menu-text">Men</span>
          </summary>
          <ul class="submenu">
            <li><a (click)="menOversizedPlain(); toggleSidebar()">Oversized Plain T-Shirts</a></li>
            <li><a (click)="menOversizedPrinted(); toggleSidebar()">Oversized Printed T-Shirts</a></li>
          </ul>
        </details>

        <details class="menu-dropdown">
          <summary class="menu-item">
            <span class="menu-icon">👗</span>
            <span class="menu-text">Women</span>
          </summary>
          <ul class="submenu">
            <li><a (click)="womenOversizedPlain(); toggleSidebar()">Oversized Plain T-Shirts</a></li>
            <li><a (click)="womenOversizedPrinted(); toggleSidebar()">Oversized Printed T-Shirts</a></li>
          </ul>
        </details>
      </div> -->
    
  <!-- </aside> -->
<!-- </div> -->

<!-- Mobile toggle button -->
<!-- <button class="sidebar-toggle" (click)="toggleSidebar()">☰</button> -->

  <!--Main Navigation-->
  
  <!--Main layout-->
  <!-- <main id="intro" class="bg-image" style="
        background-image: url(https://mdbootstrap.com/img/new/fluid/city/018.jpg);
        height: 100vh;
      ">
    <div class="mask" style="background-color: rgba(0, 0, 0, 0.7)"></div>
  </main> -->
  <router-outlet></router-outlet>
    <div *ngIf="!bestSellers && !newArrivals && !accountPage && !ordersPage && !menplain && !login && !menPrinted && !womenplain && !womenPrinted && !showAboutComponent && !viewProductComponent && !viewCartPage && !shippingPolicy && !returnExchange && !termsOfService && !privacyPolicy" class="banner">
    
      <div class="banner-container" id="banner" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
        <div class="banner-img" [attr.data-banner]="currentBanner"></div>
       
        <img class="leftArrow" src="../../assets/img/leftarrow.png" (click)="nextBanner()">
        <img class="rightArrow" src="../../assets/img/rightarrow.png" (click)="prevBanner()">
        <!-- <img class="banner-img" src="../../assets/img/sample1351_560.png" > -->
       <!-- <img class="banner-img" src="../../assets/img/sample1351_560.png" >
       <img class="banner-img" src="../../assets/img/sample1351_560.png" > -->
      </div>
    
        <div class="frankyFavourite">
            Frranky's Favourite
        </div>
        <div class="content">
          <img class="leftArrowProducts" src="../../assets/img/leftarrow.png"(click)="nextBannerProducts()">
          <div class="image-row" [style.width.%]="100 - 10">
            <div class="image-box" *ngFor="let product of visibleImages"  loading="lazy" (touchstart)="handleTouchStart($event, product)" (touchmove)="handleTouchMove($event, product)" (touchend)="handleTouchEnd($event, product)">
              <img  [src]="product.productImage" class="productTshirt" (click)="viewProduct(product)"  loading="lazy">
              <p class="tshirtImageDesc" >{{product.productName}}</p>
             
              
               <!-- <p *ngFor="let tshirtdesc of tshirtsDesc">{{tshirtdesc}}</p> -->
            </div>
            </div>
              <img class="rightArrowProducts" src="../../assets/img/rightarrow.png" (click)="nextBannerProducts()">
            <!-- <div>
                <img src="../../assets/img/tshirt1.jpg" class="tshirt">
            </div>
            <div>
                <img src="../../assets/img/tshirt1.jpg" class="tshirt">
            </div>
            <div>
                <img src="../../assets/img/tshirt1.jpg" class="tshirt">
            </div> -->
            
        </div>
         <!-- <img class="leftArrowProducts" src="../../assets/img/leftarrow.png"(click)="nextBannerProducts()"> -->
             <!-- <img class="rightArrowProducts" src="../../assets/img/rightarrow.png" (click)="nextBannerProducts()"> -->
      </div>
 

      
        
    

    


